const store = {
  namespaced: true,
  state: {
    sched: [],
    calendar_sched: []
  },
  getters: {},
  mutations: {
    // @ts-ignore
    get (state, val) {
      state.sched = val
      state.calendar_sched = val
    },
    // @ts-ignore
    calendarGet (state, val) {
      state.calendar_sched = val
    }
  },
  actions: {
    // @ts-ignore
    async get (context, data) {
      const resp = await context.dispatch('apiRequest', {
        url: '/cproc/user/calend',
        data,
        flag: 'silent'
      }, {root: true})
      context.commit('get', resp);
    },
    // @ts-ignore
    async calendarGet (context, data) {
      const resp = await context.dispatch('apiRequest', {
        url: '/cproc/user/calend',
        data,
        flag: 'silent'
      }, {root: true})
      context.commit('calendarGet', resp);
    }
  }
}

export default store